/**
 * @flow
 * @relayHash ea73b43fcbc392656626cae91a58fe59
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type projectJoin_MutationVariables = {|
  input: {
    opaque_id: string,
    clientMutationId?: ?string,
  },
|};
export type projectJoin_MutationResponse = {|
  +joinProject: ?{|
    +project: ?{|
      +id: string,
      +name: string,
      +users: ?$ReadOnlyArray<?{|
        +id: string,
        +user_id: string,
      |}>,
    |},
  |},
|};
*/


/*
mutation projectJoin_Mutation(
  $input: JoinProjectInput!
) {
  joinProject(input: $input) {
    project {
      id
      name
      users {
        id
        user_id
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "JoinProjectInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "joinProject",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "JoinProjectInput!"
      }
    ],
    "concreteType": "JoinProjectPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "project",
        "storageKey": null,
        "args": null,
        "concreteType": "Project",
        "plural": false,
        "selections": [
          v1,
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "name",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "users",
            "storageKey": null,
            "args": null,
            "concreteType": "ProjectUser",
            "plural": true,
            "selections": [
              v1,
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "user_id",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "operationKind": "mutation",
  "name": "projectJoin_Mutation",
  "id": null,
  "text": "mutation projectJoin_Mutation(\n  $input: JoinProjectInput!\n) {\n  joinProject(input: $input) {\n    project {\n      id\n      name\n      users {\n        id\n        user_id\n      }\n    }\n  }\n}\n",
  "metadata": {},
  "fragment": {
    "kind": "Fragment",
    "name": "projectJoin_Mutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": v0,
    "selections": v2
  },
  "operation": {
    "kind": "Operation",
    "name": "projectJoin_Mutation",
    "argumentDefinitions": v0,
    "selections": v2
  }
};
})();
(node/*: any*/).hash = 'd3aca7d81ccf26ed5c7d2d192087718e';
module.exports = node;



// WEBPACK FOOTER //
// ./src/public/relay/__generated__/projectJoin_Mutation.graphql.js